import React from 'react';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';
import LabeledCheckbox from '../LabeledCheckbox.jsx';
import { setProjectFilterHasPhotos } from '../../context/projectFilter.js';
import { useStateValue } from '../../context/state.jsx';

const FilterByPhotos = () => {
	const [{ projectFilter }, dispatch] = useStateValue();
	const handleHasPhotosChange = e => {
		dispatch(setProjectFilterHasPhotos(e.target.checked));
	};

	return (
		<Panel
			className={classnames({activeFilter: projectFilter.hasPhotos})}>
			<Panel.Heading>
				<Panel.Title toggle>Photos</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<LabeledCheckbox
						text="Activities with photos"
						textClass={projectFilter.hasPhotos ? 'isChecked' : ''}
						checked={projectFilter.hasPhotos}
						onChange={handleHasPhotosChange} />
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByPhotos;
